export default {
  resetCheckoutToken: 'true'
};



// WEBPACK FOOTER //
// ./src/constants/ParamMatches.js